import { render, staticRenderFns } from "./CustomerPlans.vue?vue&type=template&id=580ca988"
import script from "./CustomerPlans.vue?vue&type=script&lang=js"
export * from "./CustomerPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports